import Axios from 'axios';
import Cookies from 'js-cookie';

const pdfApi = Axios.create({
  baseURL: document.location.hostname.includes('eroski.es')
    ? process.env.REACT_APP_API
    : process.env.REACT_APP_API_CAPRABO,
  withCredentials: false,
  headers: {
    Accept: 'application/pdf',
    'Content-Type': 'application/json',
  },
  responseType: 'blob',
});

pdfApi.interceptors.request.use(
  (config) => {
    const configActive = config;

    const token = Cookies.get('token');
    if (token) {
      configActive.headers['X-AUTH-TOKEN'] = `${token}`;
    }
    return configActive;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const addToken = (token) => {
  pdfApi.defaults.headers['X-AUTH-TOKEN'] = token;
};

export const removeBearerToken = () => {
  // api.defaults.withCredentials = false;
  delete pdfApi.defaults.headers['X-AUTH-TOKEN'];
};

export const getCookies = () => {
  return Cookies;
};

export default pdfApi;
